<template>
    <div class="page">
        <login-box :showLogin="showLogin" @closeLogin="closeBox" ref="login"></login-box>
        <div class="page-shell">

            <div class="status-row">
                <div class="status-item">本机IP：<span class="status-value green">192.168.1.65</span></div>
                <div class="status-item">服务器IP：<span class="status-value yellow">127.0.0.1</span></div>
                <div class="status-item">试室：<span class="status-value yellow">第一试室</span></div>
            </div>

            <div class="hero">
                <div class="hero-title">卫生专业技术资格考试</div>
                <div class="hero-subtitle">本次模拟的是卫生专业技术资格考试流程</div>
            </div>

            <div class="content-card">
                <div class="intro-text">
                    标准国家人机对话系统界面：国家专业人机对话考试系统，以真实的考试界面环境训练，加强真实考场经验。
                </div>

                <div class="meta-row">
                    <div class="meta-pill">中级卫生职称</div>
                    <div class="meta-pill">主管护师</div>
                    <div class="meta-pill wide">护理学(中级) [代码：368]</div>
                </div>

                <div class="panel-grid">
                    <div v-for="(item, index) in moduleList" :key="index" class="module-card" :class="item.className"
                        @click="goLogin(item.value)">
                        <div class="module-overlay"></div>
                        <div class="module-title">{{ item.title }}</div>
                        <div class="module-link">进入机考模拟</div>
                    </div>
                </div>
            </div>

            <div class="footer-text">益题库 机考系统</div>
        </div>
    </div>

</template>

<script>
import LoginBox from "@/components/LoginBox";

export default {
    components: {
        LoginBox,
    },
    data() {
        return {
            showLogin: false,
            moduleList: [
                { title: '基础知识', className: 'soft-blue', value: 3993 },
                { title: '相关专业知识', className: 'bright-blue', value: 3992 },
                { title: '专业知识', className: 'deep-blue', value: 3994 },
                { title: '专业实践能力', className: 'cyan-blue', value: 3995 }
            ]
        };
    },
    mounted: function () {
        var query = this.$route.query;
        if (query.column_id) {
            this.column_id = query.column_id;
            //this.getList();
        }
        if (query.subject_id) {
            this.subject_id = query.subject_id;
        }

    },
    methods: {
        //判断是否登录
        IsUsersLogin() {
            let token = sessionStorage.getItem("access-token");
            console.log(token);
            if (token) {
                return true;
            } else {
                this.showLogin = true;
                this.$refs.login.getMiQrCode();
                return false;
            }
        },


        goLogin(e) {
            if (this.IsUsersLogin()) {
                this.$router.push({
                    path: "/meco/yiwei/login",
                    query: {
                        paper_id: e,
                    },
                });
            }
        },


        closeBox(e) {
            this.showLogin = false;
        },
    }
}
</script>

<style scoped>
.page {
    min-height: 100%;
    background: linear-gradient(180deg, #2b8fd4 0%, #1f79c7 48%, #1460a9 100%);
    font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

.page {
    min-height: 100vh;
    padding: 22px 24px 0;
    box-sizing: border-box;
    background:
        radial-gradient(circle at top left, rgba(255, 255, 255, 0.14) 0, rgba(255, 255, 255, 0) 34%),
        linear-gradient(180deg, #2b8fd4 0%, #1f79c7 48%, #1460a9 100%);
}

.page-shell {
    max-width: 1280px;
    min-height: calc(100vh - 32px);
    margin: 0 auto;
    display: flex;
    flex-direction: column;
}

.status-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 72px;
    font-size: 15px;
    line-height: 1.4;
    color: rgba(255, 255, 255, 0.92);
    letter-spacing: 0.5px;
    padding: 0 150px;
}

.status-value {
    font-weight: 700;
}

.status-value.green {
    color: #86f35f;
}

.status-value.yellow {
    color: #ffe057;
}

.hero {
    padding-top: 18px;
    text-align: center;
}

.hero-title {
    font-size: 54px;
    line-height: 1.08;
    font-weight: 800;
    color: #d6e9ff;
    text-shadow: 0 4px 0 rgba(16, 73, 133, 0.55);
    letter-spacing: 12px;
    margin: 10px 0;
}

.hero-subtitle {
    font-size: 18px;
    line-height: 1.35;
    color: #d6ff41;
    text-shadow: 0 2px 0 rgba(20, 92, 129, 0.45);
    margin-top: 20px;
    letter-spacing: 8px;
}

.content-card {
    margin: 32px auto 0;
    width: min(1120px, 100%);
    padding: 26px 28px 24px;
    border-radius: 24px;
    background: linear-gradient(180deg, rgba(219, 236, 249, 0.97) 0%, rgba(197, 222, 243, 0.96) 100%);
    box-shadow: 0 20px 50px rgba(9, 54, 101, 0.18);
    border: 1px solid rgba(255, 255, 255, 0.36);
    box-sizing: border-box;
}

.intro-text {
    font-size: 20px;
    line-height: 1.7;
    font-weight: 700;
    color: #28384d;
}

.meta-row {
    margin-top: 14px;
    display: grid;
    grid-template-columns: 1fr 1fr 1.2fr;
    gap: 22px;
}

.meta-pill {
    height: 42px;
    padding: 0 16px;
    border: 1px solid #6f8193;
    background: linear-gradient(180deg, rgba(242, 247, 251, 0.96) 0%, rgba(220, 231, 242, 0.96) 100%);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.68);
    display: flex;
    align-items: center;
    font-size: 18px;
    color: #40556b;
    box-sizing: border-box;
}

.meta-pill.wide {
    justify-content: center;
}

.panel-grid {
    margin-top: 28px;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 22px;
}

.module-card {
    position: relative;
    height: 220px;
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.28);
    background: linear-gradient(135deg, rgba(118, 181, 235, 0.98) 0%, rgba(74, 152, 218, 0.98) 50%, rgba(46, 132, 204, 0.98) 100%);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.24), 0 12px 26px rgba(33, 95, 151, 0.14);
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 28px 36px;
    box-sizing: border-box;
    cursor: pointer;
}

.module-card::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.14) 0%, rgba(255, 255, 255, 0) 48%, rgba(0, 0, 0, 0.04) 100%);
    pointer-events: none;
}

.module-card.soft-blue {
    background: linear-gradient(135deg, #61afe7 0%, #4a9bde 56%, #357fc7 100%);
}

.module-card.bright-blue {
    background: linear-gradient(135deg, #4fb0f2 0%, #3494df 56%, #2778c2 100%);
}

.module-card.deep-blue {
    background: linear-gradient(135deg, #5da9e5 0%, #428fd2 56%, #2c73bc 100%);
}

.module-card.cyan-blue {
    background: linear-gradient(135deg, #56b7f0 0%, #389ddd 56%, #2a82c4 100%);
}

.module-overlay {
    position: absolute;
    inset: 0;
    background: radial-gradient(circle at 30% 20%, rgba(255, 255, 255, 0.22) 0, rgba(255, 255, 255, 0) 32%);
}

.module-title {
    position: relative;
    text-align: center;
    font-size: 52px;
    line-height: 1.2;
    font-weight: 300;
    letter-spacing: 1px;
    color: rgba(245, 248, 255, 0.94);
    text-shadow: 0 2px 0 rgba(36, 88, 138, 0.32);
}

.module-link {
    position: absolute;
    right: 22px;
    bottom: 18px;
    font-size: 20px;
    color: rgba(246, 251, 255, 0.8);
}

.footer-text {
    margin-top: auto;
    padding-top: 18px;
    text-align: center;
    font-size: 16px;
    color: rgba(232, 243, 255, 0.88);
    letter-spacing: 2px;
}

@media screen and (max-width: 1200px) {
    .hero-title {
        font-size: 58px;
    }

    .hero-subtitle {
        font-size: 24px;
    }

    .module-title {
        font-size: 44px;
    }
}

@media screen and (max-width: 960px) {
    .page {
        padding-left: 16px;
        padding-right: 16px;
    }

    .status-row {
        gap: 24px;
        flex-wrap: wrap;
    }

    .hero-title {
        font-size: 44px;
    }

    .hero-subtitle {
        font-size: 20px;
    }

    .content-card {
        padding: 22px 18px 20px;
    }

    .meta-row {
        grid-template-columns: 1fr;
        gap: 14px;
    }

    .panel-grid {
        grid-template-columns: 1fr;
    }

    .module-card {
        height: 180px;
        padding: 20px 24px;
    }

    .module-title {
        font-size: 36px;
    }

    .module-link {
        font-size: 17px;
    }
}
</style>
